import { ConfigInterface, responseInterface } from 'swr';
import { api, parseUrl, useApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import { Product } from '@gik/core/models/gik/Product';

const path = 'products';

function getParams(serviceProductBundleId: number) {
  return {
    serviceProductBundleIds: serviceProductBundleId,
  };
}

export function getProductsByServiceProductBundle(serviceProductBundleId: number): ResponsePromise {
  const finalUrl = parseUrl(path, {
    deepQueryParams: getParams(serviceProductBundleId),
  });

  return api.get(finalUrl);
}

export function useProductsByServiceProductBundle<Data = Product[], Error = WordpressError>(
  serviceProductBundleId?: number,
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useApi<Data, Error>(serviceProductBundleId ? path : null, config, {
    deepQueryParams: getParams(serviceProductBundleId),
  });
}
